jQuery(document).ready(function ($) {
    if (jQuery('form div.animate-label-up').length > 0) {
        jQuery('form div.animate-label-up').each(function () {

        var inputElem = jQuery(this).find('input:first');
        if (inputElem.length === 0) {
             inputElem = jQuery(this).find('textarea:first');
        }

        var nameAttr = inputElem.attr('name');
            if (nameAttr.indexOf('_') > -1)
            {
                nameAttr = nameAttr.replace('_', ' ');
            }

        var lowerName = nameAttr.toLowerCase();
        inputElem.after('<span class="bar"></span><label class="' + lowerName + '-label f7-label">' + nameAttr + '</label>');
        });

        $('form div.animate-label-up input').focus(function () {
            console.log('as');
            $(this).siblings('label').addClass('active');
        }).blur(function () {
            $(this).siblings('label').removeClass('active');

            if ($(this).val().length > 0) {
                $(this).siblings('label').addClass('content');
            } else {
                $(this).siblings('label').removeClass('content');
            }
        });
    }
});